import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

import {
    AppRoleComponent,
    AppStatusComponent
} from '@/components';
import { AvatarComponent } from '@/components/avatar/avatar.component';
import { ValueOrPipe } from '@/pipes';

@Component({
    selector: 'app-user-details',
    templateUrl: 'view.component.html',
    imports: [
        AvatarComponent,
        DatePipe,
        AppRoleComponent,
        ValueOrPipe,
        AppStatusComponent
    ],
    standalone: true
})
export class UserViewComponent {
    constructor(
        public config: DynamicDialogConfig
    ) {
    }

    get data() {
        return this.config.data;
    }
}
